import React from "react";
import { DollarSign, Rocket, Trophy, Headphones } from "lucide-react";
import CTAButton from "./CTAButton";

const cards = [
  {
    icon: DollarSign,
    titleA: "Estratégia",
    titleB: "testada e comprovada",
    desc: "Cada passo que você vai seguir já foi executado, ajustado e validado no mundo real",
  },
  {
    icon: Rocket,
    titleA: "Funciona",
    titleB: "para iniciantes",
    desc: "O método foi construído pensando em quem ainda não tem nada — e transforma esse zero em estrutura, em movimento, em receita.",
  },
  {
    icon: Trophy,
    titleA: "Resultados",
    titleB: "em semanas",
    desc: "Você não vai esperar meses para ver se funcionou. Com execução consistente, os primeiros sinais chegam rápido",
  },
  {
    icon: Headphones,
    titleA: "Suporte",
    titleB: "contínuo",
    desc: "Travou numa etapa? Tem alguém do lado. É presença real enquanto você executa, para que nenhum obstáculo vire desculpa para parar.",
  },
];

const OpportunitySection = () => {
  return (
    <section className="section" style={{ background: "#000" }}>
      <div className="container">
        <div style={{ textAlign: "center", marginBottom: 60 }}>
          <div className="eyebrow">TIKTOKSHOP NO BRASIL</div>
          <h2 className="h-title" style={{ marginTop: 14, maxWidth: 900, marginInline: "auto" }}>
            Por que <span className="yellow">TikTok Shop</span> é a oportunidade do momento
          </h2>
          <p style={{ maxWidth: 780, margin: "26px auto 0", color: "rgba(255,255,255,0.75)", fontSize: 17, lineHeight: 1.7 }}>
            Por muito tempo, vender na internet parecia um jogo onde quem ganha é quem tem dinheiro pra anunciar. No TikTok Shop, o jogo mudou:
          </p>
          <p style={{ maxWidth: 780, margin: "18px auto 0", color: "#fff", fontSize: 17, lineHeight: 1.7 }}>
            <strong>O algoritmo entrega o seu vídeo para pessoas prontas para comprar.</strong> Isso significa que você pode começar com o que você já tem hoje: um <strong className="yellow">celular, consistência e uma estrutura que funciona.</strong>
          </p>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: 24,
          marginTop: 60,
        }}>
          {cards.map((c, idx) => {
            const Icon = c.icon;
            return (
              <div key={idx} className="feature-card">
                <div className="icon-badge">
                  <div className="inner">
                    <Icon size={22} strokeWidth={2.5} />
                  </div>
                </div>
                <div style={{ textAlign: "center", marginTop: 22 }}>
                  <h3 style={{ fontSize: 22, fontWeight: 800, lineHeight: 1.2 }}>
                    <span className="yellow">{c.titleA}</span> <span>{c.titleB}</span>
                  </h3>
                  <p style={{ marginTop: 16, color: "rgba(255,255,255,0.7)", fontSize: 14.5, lineHeight: 1.6 }}>
                    {c.desc}
                  </p>
                  <div className="yellow-bar" />
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ marginTop: 60, textAlign: "center" }}>
          <p style={{ maxWidth: 780, margin: "0 auto 30px", color: "rgba(255,255,255,0.8)", fontSize: 16.5, lineHeight: 1.7 }}>
            <strong>Se você: nunca vendeu nada online, não tem seguidores, não quer aparecer, ou já tentou e só ficou patinando no gelo…</strong>
            <br />Você não precisa de sorte. <em className="yellow">Você precisa de método.</em>
          </p>
          <CTAButton />
        </div>
      </div>
    </section>
  );
};

export default OpportunitySection;
